import { ExternalBillingClaimStatus } from "@/Common/Api/ExternalBilling/Dto/ExternalBillingClaimStatus";
import { Guid } from "@/Common/Models/Guid";
import { PopulationBasedFundingEventWithNotesModel } from "@/Common/Models/PopulationBasedFunding/PopulationBasedFundingEventWithNotesModel";
import { BatchEligibilityCheckStatusEnum, PopulationBasedFundingEventAction, PopulationBasedFundingEventDeregisteredReason, PopulationBasedFundingEventOverrideReason, PopulationBasedFundingProposalReason, PopulationBasedFundingStatus } from "@/Common/Models/UI/Enums";
import { PopulationBasedFundingEventTask } from "./PopulationBasedFundingEventTask";

class PopulationBasedFundingPortfolioEvent {
    public Id: string;
    public PatientContactFacetId: string;
    public PatientContactId: Guid;
    public EmployeeContactFacetId: string;
    public ActionEnum: PopulationBasedFundingEventAction;
    public EffectiveDate: Date;
    public ProposalDate?: Date;
    public OverrideDate?: Date;
    public DeregisteredReasonEnum?: PopulationBasedFundingEventDeregisteredReason;
    public ProposalReason?: PopulationBasedFundingProposalReason;
    public OverrideReasonEnum?: PopulationBasedFundingEventOverrideReason;
    public DeregistrationOrProposalCustomReason?: string;
    public PatientDateOfBirth?: Date;
    public AcceptedDate?: Date;
    public AcceptedBy?: string;
    public CreatedDate: Date;
    public CreatedBy: string;
    public LastUpdatedDate?: Date;
    public LastUpdatedBy?: string;
    public DeletedDate?: Date;
    public DeletedBy?: string;
    public WillContinueTreatment: boolean;
    public IsLastInPatientHistory: boolean;
    public PatientFirstName: string;
    public PatientLastName: string;
    public Status: PopulationBasedFundingStatus;
    public ClaimStatus: ExternalBillingClaimStatus | null;
    public IsInternalProposal: boolean;
    public Tasks?: PopulationBasedFundingEventTask[];
    public BatchEligibilityCheckStatusEnum: BatchEligibilityCheckStatusEnum | null;

    constructor(init?: Partial<PopulationBasedFundingPortfolioEvent>) {
        Object.assign(this, init);
    }

    public toPopulationBasedFundingEventWithNotesModel(): PopulationBasedFundingEventWithNotesModel {
        const pbfEventWithNotes = new PopulationBasedFundingEventWithNotesModel();
        Object.assign(pbfEventWithNotes, this);
        return pbfEventWithNotes;
    }
}

export { PopulationBasedFundingPortfolioEvent };
